import {
  ApiFormWrapper,
  FormError,
  FormInput,
  FormPasswordField,
  FormSubmitButton,
} from "@/form"
import { useRegisterMutation } from "@/auth"
import { Link } from "@/base"

export default function Register() {
  const [register] = useRegisterMutation()

  return (
    <div>
      <ApiFormWrapper
        defaultValues={{
          email: "",
          password: "",
          terms: true,
        }}
        action={register}
        resetOnSuccess
      >
        <FormInput
          type="email"
          name="email"
          placeholder="Email"
          required
          className="mb-4 w-full"
        />
        <FormPasswordField
          name="password"
          placeholder="Password"
          isNewPassword
          className="mb-4 w-full"
        />
        <FormError />
        <FormSubmitButton className="w-full">Sign up</FormSubmitButton>
        <p className="pt-4 text-center text-xs text-muted-foreground">
          By continuing you agree to the{" "}
          <Link
            to="/legal/$slug"
            params={{ slug: "terms" }}
            className="underline transition-colors hover:text-foreground"
          >
            Terms
          </Link>
        </p>
      </ApiFormWrapper>
    </div>
  )
}
